export const filterOutHiddenCols = (tableConfig) => {
  let blacklist = tableConfig.hiddenColIds || [];
  return {
    ...tableConfig,
    cellData: tableConfig.cellData.filter((c) => !blacklist.includes(c.colId)),
  };
};
